import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/me.jpeg";
import Tilt from "react-parallax-tilt";
import {
  AiFillMail
} from "react-icons/ai";
import {
  SiTelegram,
  SiWhatsapp,
  Simail,
  SiSkype,
  SiDiscord
} from "react-icons/si";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={12} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              Together We <span className="purple"> Build </span> Our Value For Life
            </h1>
            <p className="home-about-body">
              I have engrossed in Architecture and driven my effort to success in the past.🤷‍♂️
              <br />
              <br />(+7 years) Schematic Design, Design Detailing, On-Site Design, & Construction Documentation, & Design Coordination, Budgeting and Estimating
              <i>
                <b className="purple"> & AutoCAD, SketchupPro, &(+10 Years) Autodesk Revit, & Adobe Photoshop, & Adobe InDesign, & Adobe Illustrator, & Rhino 3D, & Lumion, D5 Render, </b>
              </i>
              & Twinmotion, & Vray, Concept & design thinking, 
              <br />
              <br />
              I am also an intern in creating and
              designing software in a
              <i>
                <b className="purple"> test-driven environment </b>
              </i>
              and always keep staying
              <i>
                <b className="purple"> up-to-date </b>
              </i>
              on the
              latest web technologies and seeking an opportunity to improve frontend and increase
              customer satisfaction.
            </p>
          </Col>
          {/* <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col> */}
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="mailto:lucas.nilsen1201@gmail.com"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillMail />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
